<div class="query-chat-container">
  <po-page-default p-title="Chatbot - Dados & Devops">
    <div class="po-row full-height">
      <div class="po-md-12 full-height">
        <ai-chat
          [response]="response"
          [loading]="loading"
          [literals]="literals"
          (question)="onQuestion($event)">
        </ai-chat>
      </div>
    </div>
  </po-page-default>
</div>
